<template>

    <div class="w-full lg:w-1/5 px-2 mb-5 select-none">
        <div id="holder" class="h-auto bg-black p-3" v-on:click="clickedVideoToPlay(video)">
            <div class="w-full pb-2 content-center relative">
                <h3>{{ video.user.name }}</h3>
                <span class="float-right absolute pin-r pin-t">{{ video.created_at | parseTimeAgo }}</span>
            </div>
            <div id="anim" class="relative">
                <progressive-img class="img-responsive-16by9 rounded-lg z-0" :src="thumbnailImage(video.created_at, video.upload_id)" />
                <div class="absolute pin-r pin-b mb-2 mr-2 py-1 px-2 bg-black rounded z-50" style="opacity: 0.9">
                    {{ video.length | parseSecondsToTime }}
                </div>
            </div>
            <h3 class="w-full text-sm pt-1 truncate">
                {{video.title}}
            </h3>
            <!-- <div class="w-full text-sm -mx-1 -my-1 overflow-hidden">
            <span class="rounded bg-grey-dark uppercase px-2 py-1 text-xs font-bold mx-1 inline-block my-1" v-for="location in video.locations">{{ location }}</span>
            </div> -->
        </div>
    </div>

</template>

<script>

    import { EventBus } from '../events'
    import moment from 'moment'

    export default {
        name: 'LatestVideo',
        props: [
            'video'
        ],
        methods: {
            thumbnailImage(date, id) {
                var date = moment.utc(date);
                var isAfter = moment(date).isAfter('2018-05-27 00:06:00');

                if(isAfter) {
                    return 'https://media-preview.livestormsvideo.com/thumbnails/' + date.year() + "/" + (date.month() + 1) + "/" + date.date() + "/" + id + "-00001.png";
                }
                return 'https://lsm-mms.s3.amazonaws.com/thumbnails/' + date.year() + "/" + (date.month() + 1) + "/" + date.date() + "/" + id + "-1.jpg";
            },
            clickedVideoToPlay(video) {
                EventBus.$emit('toggle-modal:videoPreview', video);
            }
        },
        filters: {
            parseDateTimeToLocal: function(timestamp) {
                return moment.utc(timestamp).local().format('MMMM D, Y h:mm A')
            },
            parseTimeAgo: function(timestamp) {
                return moment.utc(timestamp).fromNow()
            },
            parseSecondsToTime: function(value) {
                if(value !== null) {
                    var seconds = Math.floor( value % 60 ).toString();
                    var minutes = Math.floor( value / 60 ).toString();
                    if( seconds.length === 1 ){
                        seconds = '0' + seconds;
                    }
                    return minutes + ':' + seconds;
                }
            }
        }
    }

</script>

<style>

    #holder:active #anim {
        transform: scale(0.97)
    }

    .bg_icon {
        font-size: 110px;
        -webkit-transform: rotate(20deg);
        transform: rotate(20deg);
        right: -30px;
        top: -20px;
        opacity: .1;
    }

    .img-responsive-16by9 {
        display: block;
        height: 0;
        padding-bottom: 56.25%;
        overflow: hidden;
    }

</style>
